<template>
  <div class="modal-body-content-modal-background">
    <div class="modal-body-content-modal" style="width: 100%; height: 100%;">
      <div class="modal-body-edit-box">
        <div class="modal-body-edit-box-title">
          <h2>{{ isEditing ? $t('modify_authority') : $t('add_authority') }}</h2>
          <img src="@/assets/images/x_black.svg" @click="closeEdithAuth()"/>
        </div>
        <div class="modal-body-edit-box-content">
          <div class="modal-body-edit-box-content-main">
            <table>
              <tbody>
                <!-- <tr><td><input type="checkbox" v-model="isActivate" title="권한 활성화/비활성화"/>활성화</td></tr> -->
                <tr>
                  <th>{{ $t('authority') }} {{ $t('name') }}</th>
                  <td><input v-model="authName" :placeholder="$t('enter_your_authority_name')" required /></td>
                </tr>
                <tr>
                  <th><img src="@/assets/images/calendar-date.svg" />{{ $t('set_period') }}</th>
                  <td><input type="date" v-model="startDate" style="margin-right: 5px;"/><input type="date" v-model="endDate"/></td>
                </tr>
                <tr>
                  <th><img src="@/assets/images/clock.svg" />{{ $t('set_time') }}</th>
                  <td><input type="time" v-model="startTime" style="margin-right: 5px;"/><input type="time" v-model="endTime"/></td>
                </tr>
                <tr style="display: flex;">
                  <th><img src="@/assets/images/calendar-day.svg" />{{ $t('set_days') }}</th>
                  <td class="set-days">
                    <label v-for="day in dayMapping" :key="day" style="width: 43px;">
                      <input type="checkbox" v-model="selectedDays" :value="day" />
                      {{ $t(day) }}
                    </label>
                  </td>
                </tr>
                <tr>
                  <th><img src="@/assets/images/layer.svg" />{{ $t('set_priority') }}</th>
                  <td><input v-model="priority" :placeholder="$t('enter_your_authority_priority')" required type="number" /></td>
                </tr>
              </tbody>
            </table>
            <div v-show="getIsMobile()" class="button-group" style="margin-top: -15px; margin-bottom: -5px; height: 30px;">
              <button style="height: 30px; font-size: 12px;" @click.stop="controlPanel('group')" class="cancel-button" :style="selectedPanel === 'group' ? { borderColor: 'blue' } : {}">{{ $t('select_group') }}</button>
              <button style="height: 30px; font-size: 12px;" @click.stop="controlPanel('device')" class="cancel-button" :style="selectedPanel === 'device' ? { borderColor: 'blue' } : {}">{{ $t('select_device') }}</button>
              <button style="height: 30px; font-size: 12px;" @click.stop="controlPanel('gf')" class="cancel-button" :style="selectedPanel === 'gf' ? { borderColor: 'blue' } : {}">{{ $t('select_geofence') }}</button>
            </div>
            <div id="geoMap" style="height: 200px;" v-show="!getIsMobile() ? true : !mobileControl"></div>
            <div class="button-group" v-show="!getIsMobile() ? true : !mobileControl">
              <button type="button" @click.stop="closeEdithAuth()" class="cancel-button">{{ $t('cancel') }}</button>
              <button v-if="selectedAuth && !selectedAuth.is_deleted" type="button" @click.stop="deleteAuth(selectedAuth.auth_id)" class="delete-button">{{ $t('delete') }}</button>
              <button v-else-if="selectedAuth && selectedAuth.is_deleted" type="button" @click.stop="restoreAuth(selectedAuth.auth_id)" class="retrieve-button">{{ $t('restore') }}</button>
              <button type="button" @click.stop="isEditing ? updateAuth() : saveAuth()" class="action-button">{{ $t('submit') }}</button>
            </div>
          </div>

          <!-- <div v-show="!getIsMobile() ? true : selectedPanel === 'group'" class="modal-body-list-box" style="width: 330px; gap: 10px;" :style="getIsMobile() ? { minHeight: 'calc(100% - 258px)', height: 'calc(100% - 258px)', gap: '0' } : {}">
            <div class="search-box-in-title" style="margin-top: 10px; padding-right: 10px;">
              <h2 style="padding-left: 5px; width: 158px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;" :title="$t('select_group')">{{ $t('group') }}</h2>
              <input v-model="searchActiveGroup" :placeholder="$t('insert_search_query')" style="width: 130px; margin: 0;"/>
            </div>
            <div style="padding: 10px;" :style="getIsMobile() ? { height: 'calc(100% - 50px)' } : { height: 'calc(100% - 70px)' }">
              <table style="padding: 0; height: 100%;">
                <thead>
                  <tr style="display: flex;">
                    <th class="w10p"><input type="checkbox" v-model="isSelectedAllGroup" @change="toggleSelectAllGroup" /></th>
                    <th class="w65p" @click="toggleSort('group_active', 'group_name')">
                      {{ $t('group') }} {{ $t('name') }}
                      <span v-if="sortStates.group_active.find(col => col.id === 'group_name').order">
                        <img v-if="sortStates.group_active.find(col => col.id === 'group_name').order === 1" src="@/assets/images/sort_up.svg" style="width: 20px;" />
                        <img v-else src="@/assets/images/sort_down.svg" style="width: 20px;" />
                      </span>
                      <span v-else><img src="@/assets/images/sort_none.svg" style="padding: 0;"/></span>
                    </th>
                    <th class="w25p" @click="toggleSort('group_active', 'device_count')">
                      {{ $t('device') }} {{ $t('count') }}
                      <span v-if="sortStates.group_active.find(col => col.id === 'device_count').order">
                        <img v-if="sortStates.group_active.find(col => col.id === 'device_count').order === 1" src="@/assets/images/sort_up.svg" style="width: 20px;" />
                        <img v-else src="@/assets/images/sort_down.svg" style="width: 20px;" />
                      </span>
                      <span v-else><img src="@/assets/images/sort_none.svg" style="padding: 0;"/></span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="group in filteredActiveListGroup" :key="group.group_id" @click.stop="touchRow(group)">
                    <td class="w10p"><input type="checkbox" :checked="selectedGroups.includes(group.group_id)" @click.stop="touchRow(group)" /></td>
                    <td :title="group.group_name" class="w65p">
                      {{ group.group_name }}
                    </td>
                    <td :title="group.device_name_list" class="w25p" style="text-align: center; padding-left: 0;">
                      {{ group.device_count }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div> -->

          <div v-show="!getIsMobile() ? true : selectedPanel === 'device'" class="modal-body-list-box" style="width: 330px; gap: 10px;" :style="getIsMobile() ? { minHeight: 'calc(100% - 258px)', height: 'calc(100% - 258px)', gap: '0' } : {}">
            <div class="search-box-in-title" style="margin-top: 10px; padding-right: 10px;">
              <h2 style="padding-left: 5px; width: 158px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;" :title="$t('select_device')">{{ $t('device') }}</h2>
              <input v-model="searchActiveDevice" :placeholder="$t('insert_search_query')" style="width: 130px; margin: 0;"/>
            </div>
            <div style="padding: 10px;" :style="getIsMobile() ? { height: 'calc(100% - 50px)' } : { height: 'calc(100% - 70px)' }">
              <table style="padding: 0; height: 100%;">
                <thead>
                  <tr style="display: flex;">
                    <th class="w10p"><input type="checkbox" v-model="isSelectedAllDevice" @change="toggleSelectAllDevice" /></th>
                    <th class="w45p" @click="toggleSort('device_active', 'device_name')">
                      {{ $t('device') }} {{ $t('name') }}
                      <span v-if="sortStates.device_active.find(col => col.id === 'device_name').order">
                        <img v-if="sortStates.device_active.find(col => col.id === 'device_name').order === 1" src="@/assets/images/sort_up.svg" style="width: 20px;" />
                        <img v-else src="@/assets/images/sort_down.svg" style="width: 20px;" />
                      </span>
                      <span v-else><img src="@/assets/images/sort_none.svg" style="padding: 0;"/></span>
                    </th>
                    <th class="w45p" @click="toggleSort('device_active', 'group_name')">
                      {{ $t('group') }} {{ $t('name') }}
                      <span v-if="sortStates.device_active.find(col => col.id === 'group_name').order">
                        <img v-if="sortStates.device_active.find(col => col.id === 'group_name').order === 1" src="@/assets/images/sort_up.svg" style="width: 20px;" />
                        <img v-else src="@/assets/images/sort_down.svg" style="width: 20px;" />
                      </span>
                      <span v-else><img src="@/assets/images/sort_none.svg" style="padding: 0;"/></span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="device in filteredActiveListDevice" :key="device.device_id" @click.stop="touchRow(device)">
                    <td class="w10p"><input type="checkbox" :checked="selectedDevices.includes(device.device_id)" @click.stop="touchRow(device)" /></td>
                    <td :title="device.device_name" class="w45p">
                      {{ device.device_name }}
                    </td>
                    <td :title="device.group_name" class="w45p">
                      {{ device.group_name }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div v-show="!getIsMobile() ? true : selectedPanel === 'gf'" class="modal-body-list-box" style="width: 330px; gap: 10px;" :style="getIsMobile() ? { minHeight: 'calc(100% - 258px)', height: 'calc(100% - 258px)', gap: '0' } : {}">
            <div class="search-box-in-title" style="margin-top: 10px; padding-right: 10px;">
              <h2 style="padding-left: 5px; width: 158px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;" :title="$t('select_geofence')">{{ $t('geofence') }}</h2>
              <input v-model="searchActiveGeofence" :placeholder="$t('insert_search_query')" style="width: 130px; margin: 0;"/>
            </div>
            <div style="padding: 10px;" :style="getIsMobile() ? { height: 'calc(100% - 50px)' } : { height: 'calc(100% - 70px)' }">
              <table style="padding: 0; height: 100%;">
                <thead>
                  <tr style="display: flex;">
                    <th class="w10p"><input type="checkbox" v-model="isSelectedAllGeofence" @change="toggleSelectAllGeofence" /></th>
                    <th class="w90p" @click="toggleSort('geofence_active', 'geofence_name')">
                      {{ $t('geofence') }} {{ $t('name') }}
                      <span v-if="sortStates.geofence_active.find(col => col.id === 'geofence_name').order">
                        <img v-if="sortStates.geofence_active.find(col => col.id === 'geofence_name').order === 1" src="@/assets/images/sort_up.svg" style="width: 20px;" />
                        <img v-else src="@/assets/images/sort_down.svg" style="width: 20px;" />
                      </span>
                      <span v-else><img src="@/assets/images/sort_none.svg" style="padding: 0;"/></span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="geofence in filteredActiveListGeofence" :key="geofence.geofence_id" @click.stop="touchRow(geofence)">
                    <td class="w10p"><input type="checkbox" :checked="selectedGeofences.includes(geofence.geofence_id)" @click.stop="touchRow(geofence)" /></td>
                    <td :title="geofence.geofence_name" class="w90p">
                      {{ geofence.geofence_name }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  
<script setup>
import { ref, onMounted, computed, watch } from 'vue';
import L from 'leaflet';
import { device_list, geofence_list, GET_SERVER_REQUEST, group_list, SERVER_REQUEST } from '../utils/ServerConnect';
import { ConvertDateTimeString, getIsMobile } from '../utils/GlobalUtility'
import { showNotification } from '@/utils/Notification';
import { loadingStore } from '@/utils/LoadingStore';
import { closeEdithAuth, selectedAuth } from '@/utils/ModalUtility';
import { sortedActiveDeviceList, sortedActiveGFList, sortedActiveGroupList, sortStates, toggleSort } from '@/utils/SortUtility';
import { CalculateCircleBoundary, firstMapSetting } from '@/utils/MapSetting';

const selectedAuthID = ref(null);
const authName = ref('');
const startDate = ref(ConvertDateTimeString(new Date(), 'YYYY-MM-DD'));
const endDate = ref(ConvertDateTimeString(new Date(), 'YYYY-MM-DD'));
const startTime = ref(ConvertDateTimeString(new Date(), 'HH:MM'));
const endTime = ref(ConvertDateTimeString(new Date(), 'HH:MM'));
const priority = ref(0);
const selectedDevices = ref([]);
const selectedGroups = ref([]);
const selectedGeofences = ref([]);
const dayMapping = [ "Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat" ];
const selectedDays = ref([]);
const isActivate = ref(true);

const isEditing = ref(false);

const geoMap = ref(null);

const selectedPanel = ref(); // 'group', 'device', 'gf' 중 하나
const mobileControl = computed(() => {
  return selectedPanel.value ? true : false;
});
const controlPanel = (panel) => {
  if (selectedPanel.value === panel) selectedPanel.value = null;
  else selectedPanel.value = panel;
}

onMounted(async () => {
  geoMap.value = await firstMapSetting('geoMap', 17);
  browseAuth();
  loadingStore.hideLoading();
});
  
  // 권한 조회
const browseAuth = async () => {
  if (!selectedAuth.value) isEditing.value = false;
  else {
    isEditing.value = true;
    selectedAuthID.value = selectedAuth.value.auth_id;
    authName.value = JSON.parse(JSON.stringify(selectedAuth.value.auth_name));
    startDate.value = JSON.parse(JSON.stringify(selectedAuth.value.start_date));
    endDate.value = JSON.parse(JSON.stringify(selectedAuth.value.end_date));
    startTime.value = JSON.parse(JSON.stringify(selectedAuth.value.start_time));
    endTime.value = JSON.parse(JSON.stringify(selectedAuth.value.end_time));
    selectedDays.value = JSON.parse(JSON.stringify(selectedAuth.value.auth_day));
    isActivate.value = Boolean(JSON.parse(JSON.stringify(selectedAuth.value.is_activated)));
    priority.value = JSON.parse(JSON.stringify(selectedAuth.value.priority));
    selectedDevices.value = JSON.parse(JSON.stringify(selectedAuth.value.devices));
    selectedGroups.value = JSON.parse(JSON.stringify(selectedAuth.value.groups));
    selectedGeofences.value = JSON.parse(JSON.stringify(selectedAuth.value.geofences));
  }

  device_list.value = await GET_SERVER_REQUEST('device');
  group_list.value = await GET_SERVER_REQUEST('group');
  geofence_list.value = await GET_SERVER_REQUEST('geofence');

  const mapGroup = new Map(group_list.value.map(group => [group.group_id, group.group_name]));
  device_list.value = device_list.value.map(group => ({
    ...group,
    group_name: mapGroup.get(group.group_id) || null
  }));
  group_list.value = group_list.value.map(group => ({
    ...group,
    device_count: device_list.value.filter(device => group.group_id === device.group_id && !device.is_deleted)?.length || 0,
    device_id_list: device_list.value.filter(device => group.group_id === device.group_id && !device.is_deleted)?.map(device => device.device_id).join(","),
    device_name_list: device_list.value.filter(device => group.group_id === device.group_id && !device.is_deleted)?.map(device => device.device_name).join(","),
  }));

};

const updateAuth = async () => {
  if (!authName.value) {
    showNotification('Enter auth name.', 'warn', 'top-center');
    return;
  }

  const jsonData = JSON.stringify(totalData.value);
  await SERVER_REQUEST('auth', 'PUT', jsonData);
  const reGet = await GET_SERVER_REQUEST('auth', '/?auth_id=' + selectedAuthID.value);
  selectedAuth.value = reGet[0];
  resetForm();
};

const saveAuth = async () => {
  if (!authName.value) {
    showNotification('Enter auth name.', 'warn', 'top-center');
    return;
  }

  const jsonData = JSON.stringify(totalData.value);
  await SERVER_REQUEST('auth', 'POST', jsonData);
  resetForm();
  closeEdithAuth();
};

const totalData = computed(() => {
  const data = {
    ...(selectedAuthID.value ? { auth_id: selectedAuthID.value } : {}),
    auth_name: authName.value,
    startdate: startDate.value,
    enddate: endDate.value,
    starttime: startTime.value,
    endtime: endTime.value,
    auth_day: selectedDays.value,
    priority: priority.value,
    is_activated: isActivate.value,
    devices: selectedDevices.value,
    groups: selectedGroups.value,
    geofences: selectedGeofences.value,
  }
  return data
});

// 그룹 목록의 행을 선택 시 해당 행이 체크 / 체크해제 되도록
const touchRow = (obj) => {
  if (obj.device_id) {
    if (selectedDevices.value.indexOf(obj.device_id) < 0) {
      selectedDevices.value.push(obj.device_id);  
    } else {
      selectedDevices.value = selectedDevices.value.filter((element) => element !== obj.device_id);
    }
  } else if (obj.group_id) {
    if (selectedGroups.value.indexOf(obj.group_id) < 0) {
      selectedGroups.value.push(obj.group_id);  
    } else {
      selectedGroups.value = selectedGroups.value.filter((element) => element !== obj.group_id);
    }
  } else if (obj.geofence_id) {
    if (selectedGeofences.value.indexOf(obj.geofence_id) < 0) {
      selectedGeofences.value.push(obj.geofence_id);  
    } else {
      selectedGeofences.value = selectedGeofences.value.filter((element) => element !== obj.geofence_id);
    }
  }
};

const resetForm = () => {
  selectedAuthID.value = null;
  authName.value = '';
  startDate.value = ConvertDateTimeString(new Date(), 'YYYY-MM-DD');
  endDate.value = ConvertDateTimeString(new Date(), 'YYYY-MM-DD');
  startTime.value = ConvertDateTimeString(new Date(), 'HH:MM');
  endTime.value = ConvertDateTimeString(new Date(), 'HH:MM');
  selectedDays.value = [];
  priority.value = 0;
  isActivate.value = true;
  device_list.value = [];
  selectedDevices.value = [];
  group_list.value = [];
  selectedGroups.value = [];
  geofence_list.value = [];
  selectedGeofences.value = [];
  isEditing.value = false;

  browseAuth();
};

const deleteAuth = async (id) => {
  const totalData = {
    auth_id: id
  }
  const jsonData = JSON.stringify(totalData);
  await SERVER_REQUEST('auth', 'DELETE', jsonData);

  resetForm();
  closeEdithAuth();
};

const restoreAuth = async (id) => {
  const totalData = {
    auth_id: id,
    undelete: true
  }
  const jsonData = JSON.stringify(totalData);

  await SERVER_REQUEST('auth', 'DELETE', jsonData);

  resetForm();
  closeEdithAuth();
};

const isSelectedAllDevice = ref(false);
const searchActiveDevice = ref("");
// 검색어에 따라 필터링된 목록을 반환
const filteredActiveListDevice = computed(() => {
  const query = searchActiveDevice.value.trim().toLowerCase(); // 공백 제거 & 소문자 변환

  return sortedActiveDeviceList.value.filter(device =>
  String(device.device_id).toLowerCase().includes(query) // ID로 검색
    || String(device.device_name).toLowerCase().includes(query) // 이름으로 검색
    || String(device.group_name).toLowerCase().includes(query) // 그룹으로 검색
    || String(device.update_interval).toLowerCase().includes(query) // 주기로 검색
  );
});
const toggleSelectAllDevice = () => {
  if (isSelectedAllDevice.value) {
    filteredActiveListDevice.value.forEach(device => selectedDevices.value.push(device.device_id));
  } else {
    // selectedGroups에서 device_id 값들을 제거
    selectedDevices.value = selectedDevices.value.filter(id => 
      !filteredActiveListDevice.value.some(device => device.device_id === id)
    );
  }
}
watch([selectedDevices, filteredActiveListDevice], () => {
  if (filteredActiveListDevice.value.every(device => selectedDevices.value.includes(device.device_id))) isSelectedAllDevice.value = true;
  else isSelectedAllDevice.value = false;
}, { deep: true }); // deep: true 를 사용하는 이유는 내부 속성 변화까지 모두 감지하게 하기 위함

const isSelectedAllGroup = ref(false);
const searchActiveGroup = ref("");
// 검색어에 따라 필터링된 목록을 반환
const filteredActiveListGroup = computed(() => {
  const query = searchActiveGroup.value.trim().toLowerCase(); // 공백 제거 & 소문자 변환

  return sortedActiveGroupList.value.filter(group =>
  String(group.group_name).toLowerCase().includes(query) // ID로 검색
    || String(group.device_count).includes(query) // 이름으로 검색
  );
});
// const toggleSelectAllGroup = () => {
//   if (isSelectedAllGroup.value) {
//     filteredActiveListGroup.value.forEach(group => selectedGroups.value.push(group.group_id));
//   } else {
//     // selectedGroups에서 group_id 값들을 제거
//     selectedGroups.value = selectedGroups.value.filter(id => 
//       !filteredActiveListGroup.value.some(group => group.group_id === id)
//     );
//   }
// }
watch([selectedGroups, filteredActiveListGroup], () => {
  if (filteredActiveListGroup.value.every(group => selectedGroups.value.includes(group.group_id))) isSelectedAllGroup.value = true;
  else isSelectedAllGroup.value = false;
}, { deep: true }); // deep: true 를 사용하는 이유는 내부 속성 변화까지 모두 감지하게 하기 위함

const isSelectedAllGeofence = ref(false);
const searchActiveGeofence = ref("");
// 검색어에 따라 필터링된 목록을 반환
const filteredActiveListGeofence = computed(() => {
  const query = searchActiveGeofence.value.trim().toLowerCase(); // 공백 제거 & 소문자 변환

  return sortedActiveGFList.value.filter(gf =>
    String(gf.geofence_name).toLowerCase().includes(query) // 이름으로 검색
  );
});
const toggleSelectAllGeofence = () => {
  if (isSelectedAllGeofence.value) {
    filteredActiveListGeofence.value.forEach(gf => selectedGeofences.value.push(gf.geofence_id));
  } else {
    // selectedGeofences에서 geofence_id 값들을 제거
    selectedGeofences.value = selectedGeofences.value.filter(id => 
      !filteredActiveListGeofence.value.some(gf => gf.geofence_id === id)
    );
  }
}
watch([selectedGeofences, filteredActiveListGeofence], () => {
  if (filteredActiveListGeofence.value.every(gf => selectedGeofences.value.includes(gf.geofence_id))) isSelectedAllGeofence.value = true;
  else isSelectedAllGeofence.value = false;

  drawPolygon(geofence_list.value.filter(gf => selectedGeofences.value.includes(gf.geofence_id)))
}, { deep: true }); // deep: true 를 사용하는 이유는 내부 속성 변화까지 모두 감지하게 하기 위함
let polygonLayer = [];
// 폴리곤 생성 함수
const drawPolygon = (geofences) => {
  if (polygonLayer) polygonLayer.forEach(polygon => { geoMap.value.removeLayer(polygon); }); // 기존 폴리곤이 있다면 삭제
  polygonLayer = [];
  let bounds = L.latLngBounds();
  geofences.forEach(geofence => {
    const latlngs = geofence.data.locations; // 남아있는 마커들의 좌표 가져오기
    if (latlngs.length > 2) {
      polygonLayer.push(L.polygon(latlngs, { color: 'blue', type: "polygon" }).addTo(geoMap.value));  // 3개 이상의 마커가 있을 때만 폴리곤을 그림
      bounds.extend(latlngs);
    }
    if (latlngs.length === 1) {
      const radius = geofence.type.substr(geofence.type.indexOf('#') + 1)
      polygonLayer.push(L.circle(latlngs[0], { radius: radius, color: 'blue', fillOpacity: 0.2, type: "polygon" }).addTo(geoMap.value)); // 1개 일경우 원
      bounds.extend(CalculateCircleBoundary(latlngs[0].lat, latlngs[0].lng, radius));
    }
  });

  if (geofences.length > 0) geoMap.value.fitBounds(bounds, { padding: [20, 20] }); // 약간의 여백 추가
};
</script>